import { Icon, Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { FormEvent, useEffect, useRef, useState } from "react";
import { styled } from "styled-components";
import { Button } from "./Button";

const Container = styled.div`
  margin: 1rem;
`;

export type OtherAmountProps = {
  themeColor: string;
  onSubmit: (amount: number) => void;
  onCancel: () => void;
};

export const OtherAmount = (props: OtherAmountProps) => {
  const { onSubmit, onCancel, themeColor } = props;
  const [amount, setAmount] = useState(0);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit(amount);
  };

  return (
    <Container>
      <form onSubmit={handleSubmit}>
        <InputGroup>
          <InputLeftElement
            pointerEvents="none"
            children={
              <Icon
                fill={themeColor}
                width="16px"
                height="16px"
                viewBox="-6 0 24 24"
              >
                <path d="m12.496 15.87c.001.027.001.06.001.092 0 1.326-.507 2.534-1.337 3.441l.003-.004c-.881.967-2.081 1.63-3.432 1.824l-.031.004v2.344.016c0 .228-.185.413-.413.413-.006 0-.011 0-.017 0h.001-1.807c-.236-.003-.426-.193-.429-.429v-2.344c-.64-.088-1.216-.233-1.766-.434l.059.019c-.898-.305-1.678-.726-2.37-1.254l.02.015c-.233-.169-.435-.334-.629-.509l.007.006q-.167-.16-.234-.24c-.074-.074-.12-.176-.12-.289 0-.099.036-.19.095-.261l-.001.001 1.379-1.808c.073-.093.183-.154.307-.16h.001c.018-.003.038-.005.06-.005.105 0 .199.049.26.126l.001.001.026.026c.885.81 1.987 1.398 3.208 1.666l.046.009c.298.068.64.107.991.107.018 0 .04.001.062.001.691 0 1.331-.216 1.858-.584l-.011.007c.501-.342.826-.91.826-1.554 0-.028-.001-.056-.002-.083v.004c0-.263-.075-.508-.204-.715l.003.006c-.127-.214-.276-.398-.447-.559l-.001-.001c-.227-.191-.485-.359-.761-.493l-.022-.01q-.536-.274-.88-.429t-1.071-.435q-.522-.214-.824-.335t-.824-.355-.837-.415-.757-.475c-.27-.175-.506-.363-.721-.57l.001.001c-.2-.203-.391-.416-.57-.64l-.013-.016c-.185-.224-.345-.48-.467-.756l-.008-.021c-.107-.25-.204-.547-.275-.854l-.007-.036c-.072-.307-.114-.66-.114-1.022 0-.008 0-.016 0-.024v.001c0-.009 0-.02 0-.031 0-1.25.501-2.384 1.314-3.21l-.001.001c.89-.922 2.063-1.566 3.379-1.789l.036-.005v-2.415c0-.001 0-.003 0-.004 0-.117.049-.223.127-.298.075-.078.181-.127.298-.127h.003 1.808.016c.228 0 .413.185.413.413v.017-.001 2.357c.55.058 1.052.167 1.533.323l-.053-.015c.459.14.845.293 1.216.471l-.052-.022c.328.163.607.33.871.516l-.02-.014q.4.282.522.388t.201.187c.082.071.133.176.133.292 0 .081-.025.156-.067.218l.001-.001-1.082 1.956c-.055.121-.171.205-.307.214h-.001c-.025.005-.055.009-.085.009-.106 0-.203-.039-.277-.103h.001q-.04-.04-.194-.16t-.522-.355c-.219-.142-.475-.284-.741-.411l-.042-.018c-.28-.131-.612-.25-.956-.339l-.042-.009c-.343-.096-.737-.153-1.144-.154h-.001c-.046-.002-.099-.003-.153-.003-.716 0-1.382.216-1.935.587l.013-.008c-.487.327-.804.876-.804 1.499 0 .226.042.443.118.643l-.004-.012c.092.22.226.406.394.555l.002.001c.161.151.333.296.513.431l.016.011c.215.148.462.287.721.403l.03.012q.502.234.81.362t.938.368q.71.268 1.085.422t1.018.469c.394.187.725.376 1.041.587l-.029-.018c.31.22.58.44.837.675l-.006-.006c.277.242.513.522.701.835l.009.016c.166.293.309.634.413.991l.009.034c.109.365.171.785.171 1.219v.042-.002z" />
              </Icon>
            }
          />
          <Input
            ref={inputRef}
            placeholder="Enter an amount"
            focusBorderColor={themeColor + "60"}
            onChange={(e) => setAmount(Number(e.target.value))}
            type="number"
            marginBottom={"5"}
          />
        </InputGroup>
        <Button
          buttonType="secondary"
          label="Cancel"
          type="button"
          onClick={onCancel}
        />
        <Button
          buttonType="primary"
          label="Submit"
          type="submit"
          themeColor={themeColor}
        />
      </form>
    </Container>
  );
};
